<template>
  <div>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="secondary"
      class="mb-3"
    />
    <v-row dense>
      <v-col
        v-for="stat in stats"
        :key="stat.label"
        cols="6"
        sm="4"
        md="3"
      >
        <v-sheet
          rounded
          outlined
          class="pa-3 d-flex flex-column align-start"
        >
          <div class="text-caption grey--text text-uppercase">
            {{ stat.label }}
          </div>
          <component
            :is="stat.chip ? 'v-chip' : 'div'"
            v-bind="stat.chip || {}"
            class="mt-1"
            :class="stat.chip ? '' : 'title font-weight-medium'"
          >
            {{ stat.value }}
          </component>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import moment from 'moment'
  import { $k } from '@/lib/kraken'

  export default {
    name: 'OverviewTab',

    props: {
      org: { type: Object, required: true },
    },

    data: () => ({
      detail: {},
      loading: false,
    }),

    computed: {
      stats () {
        const d = this.detail || {}
        return [
          {
            label: 'Status',
            value: d.habilitado ? 'Ativa' : 'Desativada',
            chip: { color: d.habilitado ? 'success' : 'grey', small: true, dark: true },
          },
          { label: 'ID', value: d.id ?? '—' },
          { label: 'Criada em', value: this.formatDate(d.criado_em) },
          { label: 'Membros (total)', value: d.membros_total ?? 0 },
          { label: 'Membros ativos', value: d.membros_ativos ?? 0 },
          { label: 'Convites pendentes', value: d.convites_pendentes ?? 0 },
          { label: 'Agendas ativas', value: d.agendas_ativas ?? 0 },
          { label: 'Pacientes', value: d.pacientes_total ?? 0 },
          {
            label: 'Portal do paciente',
            value: this.portalText(d.portal_habilitado),
            chip: { color: this.portalColor(d.portal_habilitado), small: true, dark: true },
          },
        ]
      },
    },

    watch: {
      'org.id': {
        immediate: true,
        handler () { this.load() },
      },
    },

    methods: {
      formatDate (v) {
        if (!v) return '—'
        const m = moment(v)
        return m.isValid() ? m.format('DD/MM/YYYY') : v
      },
      portalColor (v) {
        if (v === true) return 'success'
        if (v === false) return 'grey'
        return 'warning'
      },
      portalText (v) {
        if (v === true) return 'Habilitado'
        if (v === false) return 'Desabilitado'
        return 'Não configurado'
      },
      async load () {
        if (!this.org?.id) return
        this.loading = true
        try {
          const res = await $k.manage.clinic_one.organizations._id.get({ id: this.org.id })
          this.detail = res.result || {}
        } catch (err) {
          console.error('[organizations._id.get]', err)
          this.detail = {}
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
